import CoveoAINotification from '../coveo-ai-notification/CoveoAINotification.vue';
import i18nHelper from '../../myAccount/helper/i18n-helper';
import CoveoAiIcon from '../svg-elements/coveo-ai-icon/coveoAiIcon.vue';
export default {
  name: 'CoveoAILoggedIn',
  components: {
    CoveoAINotification,
    CoveoAiIcon
  },
  data() {
    return {
      isCoveoExpanded: false,
      displayIcon: false,
      isFirstView: !localStorage.getItem('coveoAIFirstViewDone'),
      contentDescription: this.getLabel('coveo.ai.logged.in.legal'),
      triggerTitle: this.getLabel('coveo.ai.logged.in.trigger.title')
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.state.user.isAuthenticated;
    }
  },
  methods: {
    getLabel(key, value) {
      return i18nHelper.getI18nMessage(key, value);
    },
    setDisplayIcon() {
      const languageCode = this.$store.state.browser.languageCode;
      const allowedLanguages = ['en-us'];
      if (!this.isAuthenticated || !allowedLanguages.includes(languageCode)) {
        this.displayIcon = false;
        return;
      }
      this.displayIcon = true;
      if (this.isFirstView) {
        this.isCoveoExpanded = true;
        this._dismissFirstView = () => {
          this.isCoveoExpanded = false;
          this.isFirstView = false;
          localStorage.setItem('coveoAIFirstViewDone', 'true');
          document.removeEventListener('click', this._dismissFirstView, true);
        };
        document.addEventListener('click', this._dismissFirstView, true);
      }
    },
    cleanupFirstViewListener() {
      if (this._dismissFirstView) {
        document.removeEventListener('click', this._dismissFirstView, true);
        this._dismissFirstView = null;
      }
    }
  },
  watch: {
    isAuthenticated(newValue) {
      if (!newValue) {
        this.cleanupFirstViewListener();
        this.isFirstView = true;
        localStorage.removeItem('coveoAIFirstViewDone');
      }
      this.setDisplayIcon();
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.setDisplayIcon();
      }, 600);
    });
  },
  beforeUnmount() {
    this.cleanupFirstViewListener();
  }
};